import { render } from "./VerifiedSuccess.vue?vue&type=template&id=b71e10e0"
import script from "./VerifiedSuccess.vue?vue&type=script&lang=js"
export * from "./VerifiedSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__